"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _startSpeakingActivity = require("../../actions/startSpeakingActivity");

var _stopSpeakingActivity = require("../../actions/stopSpeakingActivity");

function _default(fn) {
  return (0, _effects.call)(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee() {
    var task;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _effects.take)(_startSpeakingActivity.START_SPEAKING_ACTIVITY);

          case 2:
            _context.next = 4;
            return (0, _effects.fork)(fn);

          case 4:
            task = _context.sent;
            _context.next = 7;
            return (0, _effects.take)(_stopSpeakingActivity.STOP_SPEAKING_ACTIVITY);

          case 7:
            _context.next = 9;
            return (0, _effects.cancel)(task);

          case 9:
            _context.next = 0;
            break;

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}